import { RefObject, useCallback, useEffect } from 'react'

export const useOnClickOutside = (
    ref: RefObject<HTMLElement>,
    onClick: (event: MouseEvent) => void,
    shouldHandle?: (event: MouseEvent) => boolean
) => {
    const handleClickOutside = useCallback(
        (event: Event) => {
            if (
                event instanceof MouseEvent &&
                ref.current &&
                !ref.current.contains(event.target as Node) &&
                (shouldHandle ? shouldHandle(event) : true)
            ) {
                onClick(event)
            }
        },
        [onClick, ref, shouldHandle]
    )

    useEffect(() => {
        document.addEventListener('click', handleClickOutside)
        return () => {
            document.removeEventListener('click', handleClickOutside)
        }
    }, [handleClickOutside])
}
